import { ALL_REGION } from "../constants";

const scrapperState = {
  data: [],
  error: "",
  loading: true,
  success: false,
};

export const RegionReducer = (state = scrapperState, action) => {
  switch (action.type) {
    case ALL_REGION.GET_REGIONS_FETCH:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case ALL_REGION.GET_REGIONS_SUCCESS:
      return {
        ...state,
        data: action?.payload,
        loading: false,
        error: null,
        success: true,
      };
    default:
      return state;
  }
};
